//{{-- This will make any table with class="sortable" sortable by clicking on a column header. --}}
//{{-- Also, if the table's content changes dynamically, you need to run the following line right after each change: --}}
//{{-- $('#yourTableId').removeData('originalRows'); --}}
//{{-- Successive clicks will sort up, down, and clear the sort --}}
//{{-- This goes along with the .sortable css entries in mystyle.css --}}

window.initializeSortable = function(tableSelector) {
    // Apply the 'sortableth' class for headers with text
    $(tableSelector + ' th').each(function() {
        if ($(this).text().trim) {
            $(this).addClass('sortableth');
        } else {
            $(this).removeClass('sortableth');
        } 
    });

    // Attach the sorting logic to headers
    $(tableSelector + ' th').safeOn('click', function() {
        var table = $(this).parents('table.sortable');
        var tbody = table.find('tbody');
        var idx = $(this).index();

        if (!table.data('originalRows')) {
            var originalRows = tbody.find('tr').toArray();
            table.data('originalRows', originalRows);
        }

        if (this.asc === undefined) {
            this.asc = true;
        } else if (this.asc) {
            this.asc = false;
        } else {
            delete this.asc;
        }

        if (this.asc !== undefined) {
            var sorted = tbody.find('tr').toArray().sort(comparator(idx, this.asc));
            tbody.append(sorted);
        } else {
            tbody.append(table.data('originalRows'));
        }

        updateSortIndicator(this);
        clearOtherSorts($(this));
    });
}

 window.comparator = function(idx, asc) {
    return function(a, b) {
        var valA = getCellValue(a, idx), valB = getCellValue(b, idx);
        return (valA < valB ? -1 : (valA > valB ? 1 : 0)) * (asc ? 1 : -1);
    }
}

window.getCellValue = function(row, idx) {
    return $(row).children('td').eq(idx).text();
}

window.clearOtherSorts = function(header) {
    header.siblings().each(function() {
        if (this !== header[0]) {
            delete this.asc;
            $(this).removeClass('sorted-asc sorted-desc');
        }
    });
}

window.updateSortIndicator = function(header) {
    if (header.asc === true) {
        $(header).addClass('sorted-asc').removeClass('sorted-desc');
    } else if (header.asc === false) {
        $(header).addClass('sorted-desc').removeClass('sorted-asc');
    } else {
        $(header).removeClass('sorted-asc sorted-desc');
    }
}
